import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { ReceiptCaptureComponent } from './receipt-capture.component';
import { ReceiptCaptureDetailComponent } from './detail/receipt-capture-detail.component';

import type { Routes } from '@angular/router';

const receiptCaptureRoutes: Routes = [
  {
    path: 'detail',
    component: ReceiptCaptureDetailComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    component: ReceiptCaptureComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(receiptCaptureRoutes)],
  exports: [RouterModule],
})
export class ReceiptCaptureRoutingModule {}
